// import React, { useState, useEffect } from 'react'
// import { useParams, useNavigate } from 'react-router-dom'
// import { CreateFolderForm } from '../components/family_components/CreateFolderForm/CreateFolderForm'
// import { UploadFileForm } from '../components/family_components/UploadFileForm/UploadFileForm'
// import { FilePreview } from '../components/family_components/FilePreview/FilePreview'
// import { FilePreviewPane } from '../components/family_components/FilePreviewPane/FilePreviewPane'
// import { DragDropZone } from '../components/family_components/DragDropZone/DragDropZone'
// import { ResizablePanes } from '../components/family_components/ResizablePanes/ResizablePanes'
// import ErrorBoundary from '../components/family_components/ErrorBoundary/ErrorBoundary'
// import { sanitizeFileObject } from '../../../utils/fileUtils/safeFileOperations'
// import { useFileStore } from '../../../store/useFileStore'
// import { useFamilyStore } from '../../../store/useFamilyStore'
// import ApiClient from '../../../views/api/client'

// const apiClient = new ApiClient()

// const MemberFiles = () => {
//   //n useNavigate
//   const navigate = useNavigate()

//   //useparams
//   const { clientId, memberId, folderId } = useParams()

//   // useState
//   const [showCreateFolder, setShowCreateFolder] = useState(false)
//   const [showUploadFile, setShowUploadFile] = useState(false)
//   const [currentFolder, setCurrentFolder] = useState(null)
//   const [previewFile, setPreviewFile] = useState(null)
//   const [selectedFile, setSelectedFile] = useState(null)
//   const [showPreviewPane, setShowPreviewPane] = useState(true)
//   const [loading, setLoading] = useState(true)
//   const [error, setError] = useState(null)

//   // Store hooks
//   const {
//     fetchFamilyFiles,
//     familyFiles,
//     familySubfolders,
//     fetchFamilyFolders,
//     fetchFamilySubfolders,
//     familyFolderFiles,
//     fetchFamilyFolderFiles,
//     folderFiles,
//     createFamilyFolders,
//     familyFolders,
//     createSubFolders,
//     createFamilySubFolders,
//     createFolders,
//     uploadFile,
//     deleteFile,
//     deleteFolderFile,
//     folderDelete,
//     deleteFolder,
//     fileFolderUpload,
//     uploadFileToFolder,
//     fileUpload,
//   } = useFileStore()

//   const { member, getAFamilyMember } = useFamilyStore()

//   const fam = member[memberId]

//   // Load family member and files on component mount
//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         setLoading(true)
//         setError(null)

//         // Load family member data
//         const result = await getAFamilyMember(memberId)
//         console.log('Family member result', result)

//         // Load family files
//         await fetchFamilyFiles(memberId)
//         await fetchFamilyFolders(memberId)
//         // if (currentFolder) {
//         //   await fetchFamilySubfolders(memberId, folderId)
//         //   await fetchFamilyFolderFiles(memberId, folderId)
//         // }

//         // await createFamilySubFolders(clientId, memberId, folderId)
//       } catch (err) {
//         console.error('Error loading data:', err)
//         setError('Failed to load member data or files')
//       } finally {
//         setLoading(false)
//       }
//     }

//     if (clientId && memberId) {
//       loadData()
//     }
//   }, [
//     clientId,
//     memberId,
//     folderId,
//     getAFamilyMember,
//     fetchFamilyFiles,
//     fetchFamilyFolders,
//     uploadFileToFolder,
//     uploadFile,
//     currentFolder,
//     fetchFamilySubfolders,
//     fetchFamilyFolderFiles,
//   ])

//   // Get current member data
//   // const checkArray = Array.isArray(familyMembers)

//   // if (checkArray == Array) {
//   //   console.log('Hello World!')
//   // } else {
//   //   console.log('I am not an array')
//   // }

//   //   const member = JSON.stringify(fam)

//   const memb = fam
//   console.log(memb)
//   // Debug logging to identify the issue
//   console.log('Raw member object:', member)
//   console.log('memberId:', memberId)
//   console.log('folder ID', folderId)
//   console.log('fam object:', fam)
//   console.log('fam type:', typeof fam)

//   // Get current file structure
//   // const memberKey = `${clientId}-${memberId}`
//   JSON.stringify(familyFiles, null, 2)

//   // const fileStructure = familyFiles?.[memberId]
//   //   ? {
//   //       rootFiles: familyFiles[memberId].db_files || [],
//   //     }
//   //   : { rootFiles: [] }

//   const fileStructure =
//     (familyFolders?.[memberId] && familyFiles?.[memberId]) ||
//     familySubfolders?.[memberId]?.[folderId] ||
//     familyFolderFiles?.[memberId]?.[folderId]
//       ? {
//           folders: familyFolders[memberId] || [],
//           subFolders: familySubfolders[(memberId, folderId)] || [],
//           folderFiles: familyFolderFiles[(memberId, folderId)] || [],
//           rootFiles: familyFiles[memberId].db_files || [],
//         }
//       : { rootFiles: [], folders: [], subFolders: [], folderFiles: [] }
//   console.log('Files in db_files array:', familyFiles?.[memberId])

//   // const fileFolder = familyFolders?.[memberId]?.db_folders

//   console.log('Folders contents:', fileStructure.subFolders)
//   // Loading and error states
//   if (loading) {
//     return (
//       <div className="bg-neutral-100 flex flex-row justify-center w-full min-h-screen">
//         <div className="bg-neutral-100 w-[1440px] p-8 flex items-center justify-center">
//           <div className="text-center">
//             <div className="text-4xl mb-4">⏳</div>
//             <h2 className="text-xl font-semibold mb-2">Loading...</h2>
//             <p className="text-gray-600">
//               Please wait while we load the member files
//             </p>
//           </div>
//         </div>
//       </div>
//     )
//   }

//   if (error) {
//     return (
//       <div className="bg-neutral-100 flex flex-row justify-center w-full min-h-screen">
//         <div className="bg-neutral-100 w-[1440px] p-8">
//           <div className="text-center">
//             <div className="text-4xl mb-4">❌</div>
//             <h1 className="text-2xl font-bold mb-4">Error Loading Data</h1>
//             <p className="text-red-600 mb-4">{error}</p>
//             <button
//               onClick={() => navigate(`/dashboard/client/${clientId}/family`)}
//               className="bg-[#3d6be0] text-white px-6 py-2 rounded-lg hover:bg-blue-600"
//             >
//               Back to Family Members
//             </button>
//           </div>
//         </div>
//       </div>
//     )
//   }

//   if (!memb) {
//     return (
//       <div className="bg-neutral-100 flex flex-row justify-center w-full min-h-screen">
//         <div className="bg-neutral-100 w-[1440px] p-8">
//           <div className="text-center">
//             <h1 className="text-2xl font-bold mb-4">Member Not Found</h1>
//             <button
//               onClick={() => navigate(`/dashboard/client/${clientId}/family`)}
//               className="bg-[#3d6be0] text-white px-6 py-2 rounded-lg hover:bg-blue-600"
//             >
//               Back to Family Members
//             </button>
//           </div>
//         </div>
//       </div>
//     )
//   }

//   const handleCreateFolder = async (folderName) => {
//     try {
//       if (folderId) {
//         await createFamilySubFolders(memberId, folderId, folderName)
//         setShowCreateFolder(false)
//       } else {
//         await createFamilyFolders(memberId, folderName)
//         setShowCreateFolder(false)
//       }

//       // Refresh files after creating folder
//       await fetchFamilyFolders(memberId)
//       await apiClient.fetchFamilySubfolders(memberId, folderId)
//     } catch (error) {
//       console.error('Error creating folder:', error)
//       alert('Failed to create folder. Please try again.')
//     }
//   }

//   const handleUploadFile = async (fileData) => {
//     // Comprehensive validation
//     // if (!currentFolder) {
//     //   alert('Not a folder to upload to')
//     //   return
//     // }
//     alert(fileData.url)

//     if (!fileData.name || typeof fileData.name !== 'string') {
//       alert('Invalid file data - missing or invalid name:', fileData)
//       return
//     }

//     try {
//       // const folderIdn = currentFolder ? currentFolder.id : null
//       if (currentFolder) {
//         await uploadFileToFolder(memberId, currentFolder.id, fileData.file)
//         setShowUploadFile(false)
//         await fetchFamilyFolderFiles(memberId, currentFolder.Id)
//         return navigate(
//           `/dashboard/client/${clientId}/family/${memberId}/folders/${currentFolder.id}/subfolders/`
//         )
//       } else {
//         await uploadFile(memberId, fileData.file)
//         setShowUploadFile(false)
//         await fetchFamilyFiles(memberId)
//       }

//       // Refresh files after upload
//       // await fetchFamilyFiles(memberId)
//       // await fetchFamilyFolderFiles(memberId, folderId)
//     } catch (error) {
//       console.error('Error uploading file to folder:', error)
//       alert('Error uploading file. Please try again.')
//     }
//   }

//   // handle Upload file
//   // const handleUploadFile = async (fileData) => {
//   //   // Comprehensive validation
//   //   // const newFile = {
//   //   //   uploadDate: new Date().toISOString().split('T')[0],
//   //   //   }
//   //   try {
//   //     await uploadFile(memberId, fileData)
//   //     setShowUploadFile(false)

//   //     // Refresh files after upload
//   //     await fetchFamilyFiles(memberId)
//   //   } catch (error) {
//   //     console.error('Error uploading file:', error)
//   //     alert('Error uploading file. Please try again.')
//   //   }
//   // }

//   // handle drag drop upload
//   const handleDragDropUpload = async (fileData) => {
//     await handleUploadFile(fileData)
//   }

//   const handleFolderClick = async (folder) => {
//     // const famsubfold = await fetchFamilyFolderFiles(memberId, folderId)
//     await fetchFamilySubfolders(memberId, folder.id)
//     await fetchFamilyFolderFiles(memberId, folder.id)
//     setCurrentFolder(folder)

//     if (folder.id) {
//       navigate(
//         `/dashboard/client/${clientId}/family/${memberId}/folders/${folder.id}/subfolders/`
//       )
//     }

//     // return folder.id
//   }

//   console.log('Subfolders display', familySubfolders)

//   const handleBackClick = (folderId) => {
//     if (folderId) {
//       setCurrentFolder(null)
//       return navigate(`/dashboard/client/${clientId}/family/${memberId}/files/`)
//     } else {
//       return navigate(`/dashboard/client/${clientId}/family/${memberId}/files/`)
//     }
//   }

//   const getFileIcon = (fileName) => {
//     if (!fileName || typeof fileName !== 'string') return '📎'
//     const extension = fileName.split('.').pop()?.toLowerCase() || ''
//     switch (extension) {
//       case 'pdf':
//         return '📄'
//       case 'doc':
//       case 'docx':
//         return '📝'
//       case 'xls':
//       case 'xlsx':
//       case 'csv':
//         return '📊'
//       case 'ppt':
//       case 'pptx':
//         return '📽️'
//       case 'jpg':
//       case 'jpeg':
//       case 'png':
//       case 'gif':
//       case 'bmp':
//       case 'webp':
//         return '🖼️'
//       case 'mp4':
//       case 'avi':
//       case 'mov':
//       case 'wmv':
//         return '🎬'
//       case 'mp3':
//       case 'wav':
//       case 'ogg':
//         return '🎵'
//       case 'txt':
//       case 'md':
//         return '📝'
//       default:
//         return '📎'
//     }
//   }

//   const handleFilePreview = (file) => {
//     try {
//       const safeFile = sanitizeFileObject(file)
//       if (safeFile) {
//         safeFile.icon = getFileIcon(safeFile.name)
//         alert(safeFile.name)
//         setPreviewFile(safeFile)
//       } else {
//         console.warn('Invalid file provided for preview:', file)
//         setPreviewFile(null)
//       }
//     } catch (error) {
//       console.error('Error setting preview file:', error)
//       setPreviewFile(null)
//     }
//   }

//   const handleFileSelect = (file) => {
//     try {
//       const safeFile = sanitizeFileObject(file)
//       if (safeFile) {
//         safeFile.icon = getFileIcon(safeFile.name)
//         setSelectedFile(safeFile)
//       } else {
//         console.warn('Invalid file provided to select:', file)
//         setSelectedFile(null)
//       }
//     } catch (error) {
//       console.error('Error selecting file:', error)
//       setSelectedFile(null)
//     }
//   }

//   const handleDeleteFile = async (fileId) => {
//     // Validate inputs
//     if (!fileId) {
//       console.error('No file ID provided for deletion')
//       return
//     }

//     if (!window.confirm('Are you sure you want to delete this file?')) {
//       return
//     }

//     try {
//       if (currentFolder) {
//         await deleteFolderFile(memberId, currentFolder.id, fileId)
//       } else {
//         await deleteFile(memberId, fileId)
//       }

//       // Clear preview and selection if the deleted file was selected
//       if (previewFile?.id === fileId) {
//         setPreviewFile(null)
//       }
//       if (selectedFile?.id === fileId) {
//         setSelectedFile(null)
//       }

//       // Refresh files after deletion
//       await fetchFamilyFiles(memberId)
//     } catch (error) {
//       console.error('Error deleting file:', error)
//       alert('Failed to delete file. Please try again.')
//     }
//   }

//   const handleDownloadFile = (file) => {
//     if (file.url) {
//       // Real file download
//       const link = document.createElement('a')
//       link.href = file.url
//       link.download = file.name
//       document.body.appendChild(link)
//       link.click()
//       document.body.removeChild(link)
//     } else {
//       // Simulate download for demo files
//       const blob = new Blob([`Sample content for ${file.name}`], {
//         type: 'text/plain',
//       })
//       const url = URL.createObjectURL(blob)
//       const link = document.createElement('a')
//       link.href = url
//       link.download = file.name
//       document.body.appendChild(link)
//       link.click()
//       document.body.removeChild(link)
//       URL.revokeObjectURL(url)
//     }
//   }

//   const handleDeleteFolder = async (folderId) => {
//     if (
//       window.confirm(
//         'Are you sure you want to delete this folder and all its contents?'
//       )
//     ) {
//       try {
//         await deleteFolder(memberId, folderId)

//         // If currently viewing the deleted folder, go back to main view
//         if (currentFolder && currentFolder.id === folderId) {
//           setCurrentFolder(null)
//         }

//         // Refresh files after deletion
//         await fetchFamilyFiles(memberId)
//       } catch (error) {
//         console.error('Error deleting folder:', error)
//         alert('Failed to delete folder. Please try again.')
//       }
//     }
//   }

//   return (
//     <div className="bg-neutral-100 flex flex-row justify-center w-full min-h-screen">
//       <div className="bg-neutral-100 w-full max-w-[1800px] p-8">
//         <ResizablePanes
//           showRightPane={showPreviewPane}
//           defaultLeftWidth={showPreviewPane ? 70 : 100}
//           minLeftWidth={40}
//           maxLeftWidth={85}
//           leftPane={
//             <div className="h-full pr-4">
//               {/* Header */}
//               <div className="bg-white rounded-lg p-6 mb-6">
//                 <div className="flex items-center justify-between">
//                   <div>
//                     <button
//                       onClick={() =>
//                         navigate(`/dashboard/client/${clientId}/family`)
//                       }
//                       className="text-[#3d6be0] hover:underline mb-2 flex items-center gap-2"
//                     >
//                       ← Back to Family Members
//                     </button>
//                     {/* {familyMembers[0][2] === 'primary applicant' ? (
//                       <div key>
//                         <span>{familyMembers.full_name}</span>
//                       </div>
//                     ) : (
//                       ''
//                     )} */}
//                     <h1 className="text-3xl font-bold text-black">
//                       {memb.full_name} &apos;s Files
//                     </h1>

//                     <p className="text-gray-600 mt-2">{memb.relationship}</p>

//                     {currentFolder && (
//                       <div className="mt-2">
//                         <button
//                           onClick={handleBackClick}
//                           className="text-[#3d6be0] hover:underline flex items-center gap-1"
//                         >
//                           ← Back to main folder
//                         </button>
//                         <p className="text-lg font-semibold text-gray-800 mt-1">
//                           {currentFolder.icon} {currentFolder.name}
//                         </p>
//                       </div>
//                     )}
//                   </div>

//                   {/* Action Buttons */}
//                   <div className="flex gap-3">
//                     <button
//                       onClick={() => setShowPreviewPane(!showPreviewPane)}
//                       className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-colors ${
//                         showPreviewPane
//                           ? 'bg-gray-200 text-gray-700 hover:bg-gray-300'
//                           : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//                       }`}
//                       title={
//                         showPreviewPane
//                           ? 'Hide Preview Pane'
//                           : 'Show Preview Pane'
//                       }
//                     >
//                       {showPreviewPane ? '👁️‍🗨️' : '👁️'} Preview
//                     </button>
//                     <button
//                       onClick={() => setShowCreateFolder(true)}
//                       className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 flex items-center gap-2"
//                     >
//                       📁 Create Folder
//                     </button>
//                     <button
//                       onClick={() => setShowUploadFile(true)}
//                       className="bg-[#3d6be0] text-white px-4 py-2 rounded-lg hover:bg-blue-600 flex items-center gap-2"
//                     >
//                       📤 Upload File
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               {/* File Browser */}
//               <DragDropZone
//                 onFileUpload={handleDragDropUpload}
//                 className="bg-white rounded-lg p-6"
//               >
//                 {!currentFolder ? (
//                   // Main folder view
//                   <div>
//                     <div className="flex items-center justify-between mb-4">
//                       <h2 className="text-xl font-semibold">Folders & Files</h2>
//                       <div className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
//                         💡 Drag and drop files anywhere to upload
//                       </div>
//                     </div>

//                     {/* Folders Grid */}
//                     {fileStructure.folders &&
//                       fileStructure.folders.length > 0 && (
//                         <div className="mb-8">
//                           <h3 className="text-lg font-medium mb-3 text-gray-700">
//                             Folders
//                           </h3>
//                           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//                             {fileStructure.folders.map((folder) => (
//                               <div
//                                 key={folder.id}
//                                 className="bg-gray-50 p-4 rounded-lg border border-gray-200 group relative"
//                               >
//                                 <div
//                                   className="text-center cursor-pointer"
//                                   onClick={() => handleFolderClick(folder)}
//                                 >
//                                   <div className="text-4xl mb-2">
//                                     {folder.icon || '📁'}
//                                   </div>
//                                   <p className="font-medium text-gray-800">
//                                     {folder.name}
//                                   </p>
//                                   <p className="text-sm text-gray-500">
//                                     {folder.file?.length || 0} files
//                                   </p>
//                                 </div>

//                                 {/* Delete button */}
//                                 <button
//                                   onClick={(e) => {
//                                     e.stopPropagation()
//                                     handleDeleteFolder(folder.id)
//                                   }}
//                                   className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-red-600"
//                                 >
//                                   ×
//                                 </button>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       )}

//                     {/* Root Files */}
//                     {fileStructure.rootFiles &&
//                       fileStructure.rootFiles.length > 0 && (
//                         <div>
//                           <h3 className="text-lg font-medium mb-3 text-gray-700">
//                             Files
//                           </h3>
//                           <div className="space-y-2">
//                             {fileStructure.rootFiles
//                               .filter((file) => file && file.name)
//                               .map((file) => (
//                                 <div
//                                   key={file.id || Math.random()}
//                                   className={`flex items-center justify-between p-3 rounded-lg border border-gray-200 group cursor-pointer transition-colors ${
//                                     selectedFile?.id === file.id
//                                       ? 'bg-blue-50 border-blue-300'
//                                       : 'bg-gray-50 hover:bg-gray-100'
//                                   }`}
//                                   onClick={() => handleFileSelect(file)}
//                                 >
//                                   <div className="flex items-center gap-3">
//                                     <span className="text-2xl">
//                                       {getFileIcon(file.name || '')}
//                                     </span>
//                                     <div>
//                                       <p className="font-medium text-gray-800">
//                                         {file.name || 'Unknown File'}
//                                       </p>
//                                       <p className="text-sm text-gray-500">
//                                         {file.file_size || 'Unknown size'} •{' '}
//                                         {file.created_at.slice(0, 10) ||
//                                           'Unknown date'}
//                                       </p>
//                                     </div>
//                                   </div>
//                                   <div className="flex items-center gap-2">
//                                     <button
//                                       onClick={(e) => {
//                                         e.stopPropagation()
//                                         handleFilePreview(file)
//                                       }}
//                                       className="text-[#3d6be0] hover:underline text-sm"
//                                     >
//                                       Preview
//                                     </button>
//                                     <button
//                                       onClick={(e) => {
//                                         e.stopPropagation()
//                                         handleDownloadFile(file)
//                                       }}
//                                       className="text-[#3d6be0] hover:underline text-sm"
//                                     >
//                                       Download
//                                     </button>
//                                     <button
//                                       onClick={(e) => {
//                                         e.stopPropagation()
//                                         handleDeleteFile(file.id)
//                                       }}
//                                       className="opacity-0 group-hover:opacity-100 transition-opacity text-red-500 hover:text-red-700 text-sm"
//                                     >
//                                       Delete
//                                     </button>
//                                   </div>
//                                 </div>
//                               ))}
//                           </div>
//                         </div>
//                       )}
//                     {(!fileStructure.folders ||
//                       fileStructure.folders.length === 0) &&
//                       (!fileStructure.rootFiles ||
//                         fileStructure.rootFiles.length === 0) && (
//                         <div className="text-center py-12">
//                           <div className="text-6xl mb-4">📁</div>
//                           <h3 className="text-xl font-medium text-gray-600 mb-2">
//                             No files or folders yet
//                           </h3>
//                           <p className="text-gray-500">
//                             Create a folder or upload files to get started
//                           </p>
//                         </div>
//                       )}
//                   </div>
//                 ) : (
//                   // Folder contents view
//                   <div>
//                     <div className="flex items-center justify-between mb-4">
//                       <h2 className="text-xl font-semibold">
//                         {currentFolder.icon || '📁'} {currentFolder.name} Files
//                       </h2>
//                       <div className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
//                         💡 Drag and drop files here to add to this folder
//                       </div>
//                     </div>
//                     {/* Subfolders Grid */}
//                     {fileStructure.subFolders &&
//                       fileStructure.subFolders.length > 0 && (
//                         <div className="mb-8">
//                           <h3 className="text-lg font-medium mb-3 text-gray-700">
//                             Subfolders
//                           </h3>
//                           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//                             {familySubfolders[(memberId, folderId)]
//                               .filter((file) => file)
//                               .map((sub) => (
//                                 <div
//                                   key={sub.id}
//                                   className="bg-gray-50 p-4 rounded-lg border border-gray-200 group relative"
//                                   onClick={() => handleFolderClick(sub)}
//                                 >
//                                   <div className="text-center cursor-pointer">
//                                     <div className="text-4xl mb-2">
//                                       {sub.icon || '📁'}
//                                     </div>
//                                     <p className="font-medium text-gray-800">
//                                       {sub.name}
//                                     </p>
//                                     <p className="text-sm text-gray-500">
//                                       {sub.file?.length || 0} files
//                                     </p>
//                                     {/* Delete button */}
//                                     <button
//                                       onClick={(e) => {
//                                         e.stopPropagation()
//                                         handleDeleteFolder(sub.id)
//                                       }}
//                                       className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-red-600"
//                                     >
//                                       ×
//                                     </button>
//                                   </div>
//                                 </div>
//                               ))}
//                           </div>
//                         </div>
//                       )}
//                     {fileStructure.folderFiles &&
//                     fileStructure.folderFiles.length > 0 ? (
//                       <div className="space-y-2">
//                         {fileStructure.folderFiles.map((file) => (
//                           <div
//                             key={file.id}
//                             className={`flex items-center justify-between p-3 rounded-lg border border-gray-200 group cursor-pointer transition-colors ${
//                               selectedFile?.id === file.id
//                                 ? 'bg-blue-50 border-blue-300'
//                                 : 'bg-gray-50 hover:bg-gray-100'
//                             }`}
//                             onClick={() => handleFileSelect(file)}
//                           >
//                             <div className="flex items-center gap-3">
//                               <span className="text-2xl">
//                                 {getFileIcon(file.name)}
//                               </span>
//                               <div>
//                                 <p className="font-medium text-gray-800">
//                                   {file.name}
//                                 </p>
//                                 <p className="text-sm text-gray-500">
//                                   {`created at ${file.created_at.slice(0, 10)}`}{' '}
//                                   • {new Date().toISOString}
//                                 </p>
//                               </div>
//                             </div>
//                             <div className="flex items-center gap-2">
//                               <button
//                                 onClick={(e) => {
//                                   e.stopPropagation()
//                                   handleFilePreview(file)
//                                 }}
//                                 className="text-[#3d6be0] hover:underline text-sm"
//                               >
//                                 Preview
//                               </button>
//                               <button
//                                 onClick={(e) => {
//                                   e.stopPropagation()
//                                   handleDownloadFile(file)
//                                 }}
//                                 className="text-[#3d6be0] hover:underline text-sm"
//                               >
//                                 Download
//                               </button>
//                               <button
//                                 onClick={(e) => {
//                                   e.stopPropagation()
//                                   handleDeleteFile(
//                                     file.id,
//                                     familyFolderFiles.id
//                                   )
//                                 }}
//                                 className="opacity-0 group-hover:opacity-100 transition-opacity text-red-500 hover:text-red-700 text-sm"
//                               >
//                                 Delete
//                               </button>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     ) : (
//                       <div className="text-center py-12">
//                         <div className="text-6xl mb-4">📄</div>
//                         <h3 className="text-xl font-medium text-gray-600 mb-2">
//                           No files in this folder
//                         </h3>
//                         <p className="text-gray-500">
//                           Upload files to this folder to get started
//                         </p>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </DragDropZone>

//               {/* Modals */}
//               {showCreateFolder && (
//                 <CreateFolderForm
//                   onCreateFolder={handleCreateFolder}
//                   onCancel={() => setShowCreateFolder(false)}
//                 />
//               )}

//               {showUploadFile && (
//                 <UploadFileForm
//                   onUploadFile={handleUploadFile}
//                   onCancel={() => setShowUploadFile(false)}
//                   targetFolder={currentFolder}
//                 />
//               )}

//               {previewFile && (
//                 <FilePreview
//                   file={previewFile}
//                   onClose={() => setPreviewFile(null)}
//                 />
//               )}
//             </div>
//           }
//           rightPane={
//             <div className="h-full pl-4">
//               <div className="bg-white rounded-lg p-6 h-full flex flex-col">
//                 {selectedFile ? (
//                   <>
//                     {/* File Info Header */}
//                     <div className="flex items-center gap-3 mb-4 pb-4 border-b border-gray-200 flex-shrink-0">
//                       <span className="text-3xl">
//                         {selectedFile.icon || '📎'}
//                       </span>
//                       <div className="flex-1 min-w-0">
//                         <h3 className="font-semibold text-gray-800 truncate">
//                           {selectedFile.name}
//                         </h3>
//                         <p className="text-sm text-gray-500">
//                           {selectedFile.size} • {selectedFile.uploadDate}
//                         </p>
//                       </div>
//                     </div>

//                     {/* Preview Content */}
//                     <div className="flex-1 mb-4 min-h-0">
//                       <h4 className="font-medium text-gray-700 mb-3">
//                         Preview
//                       </h4>
//                       <div className="border border-gray-200 rounded-lg overflow-hidden bg-gray-50 h-full">
//                         <ErrorBoundary>
//                           <FilePreviewPane file={selectedFile} />
//                         </ErrorBoundary>
//                       </div>
//                     </div>

//                     {/* Action Buttons */}
//                     <div className="space-y-2 flex-shrink-0">
//                       <button
//                         onClick={() => handleFilePreview(selectedFile)}
//                         className="w-full px-4 py-2 bg-[#3d6be0] text-white rounded-lg hover:bg-blue-600 transition-colors"
//                       >
//                         Full Preview
//                       </button>
//                       <button
//                         onClick={() => handleDownloadFile(selectedFile)}
//                         className="w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
//                       >
//                         Download
//                       </button>
//                       <button
//                         onClick={() => {
//                           const folderId = currentFolder
//                             ? currentFolder.id
//                             : null
//                           handleDeleteFile(selectedFile.id, folderId)
//                         }}
//                         className="w-full px-4 py-2 border border-red-300 text-red-600 rounded-lg hover:bg-red-50 transition-colors"
//                       >
//                         Delete File
//                       </button>
//                     </div>
//                   </>
//                 ) : (
//                   <div className="text-center py-12 flex-1 flex flex-col justify-center">
//                     <div className="text-6xl mb-4">👆</div>
//                     <h3 className="text-lg font-medium text-gray-600 mb-2">
//                       Select a file
//                     </h3>
//                     <p className="text-gray-500 text-sm">
//                       Click on any file to see its preview and details here
//                     </p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           }
//         />
//       </div>
//     </div>
//   )
// }

// export default MemberFiles

import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { CreateFolderForm } from '../components/family_components/CreateFolderForm/CreateFolderForm'
import { UpdateFamilyFolderModal } from '../components/family_components/UpdateFamilyFolderModal/UpdateFamilyFolderModal'
import { UploadFileForm } from '../components/family_components/UploadFileForm/UploadFileForm'
import FilePreviewModal from '../components/family_components/FilePreview/FilePreview'
import SummaryModal from '../components/family_components/Summary/SummaryModal'
import { FilePreviewPane } from '../components/family_components/FilePreviewPane/FilePreviewPane'
import { DragDropZone } from '../components/family_components/DragDropZone/DragDropZone'
import { ResizablePanes } from '../components/family_components/ResizablePanes/ResizablePanes'
import ErrorBoundary from '../components/family_components/ErrorBoundary/ErrorBoundary'
import { sanitizeFileObject } from '../../../utils/fileUtils/safeFileOperations'
import { useFileStore } from '../../../store/useFileStore'
import { useFamilyStore } from '../../../store/useFamilyStore'
import { useSearchStore } from '../../../store/useSearchStore'
import FileExplorerContext from '../components/family_components/FileExplorerContext'
import DeleteFolderModal from '../components/family_components/DeleteFolderModals'
import DeleteFileModal from '../components/family_components/DeleteFileModal'

import ApiClient from '../../../views/api/client'
import SideBar from '../components/SideBar'
import Navbar from '../components/Navbar'
import SearchBar from '../components/SearchBar'
import Logo from '../../../assets/logo.png'
import { Edit } from 'lucide-react'

const apiClient = new ApiClient()

const MemberFiles = () => {
  //n useNavigate
  const navigate = useNavigate()

  //useparams
  const { clientId, memberId, folderId } = useParams()

  // useState
  const [showCreateFolder, setShowCreateFolder] = useState(false)
  const [showUploadFile, setShowUploadFile] = useState(false)
  const [currentFolder, setCurrentFolder] = useState(null)
  const [previewFile, setPreviewFile] = useState(null)
  const [selectedFile, setSelectedFile] = useState(null)
  const [showPreviewPane, setShowPreviewPane] = useState(true)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false)
  const [contextMenu, setContextMenu] = useState(null)
  const [renamingFile, setRenamingFile] = useState(null)
  const [renamingFolder, setRenamingFolder] = useState(null)
  const [newName, setNewName] = useState('')
  const menuRef = useRef(null)
  const [refresh, setRefresh] = useState(0)
  const [numOfFile, setNumOfFile] = useState(1)
  const [files, setFiles] = useState([])
  const [showUpdateFolder, setShowUpdateFolder] = useState(false)
  const [newFolderName, setNewFolderName] = useState('')
  const [fileCount, setFileCount] = useState(1)
  const [foldId, setFolderId] = useState(null)
  const [showSummaryModal, setSummaryModal] = useState(false)
  const [showDeleteFolderModal, setShowDeleteFolderModal] = useState(false)
  const [showDeleteFileModal, setShowDeleteFileModal] = useState(false)
  const [folderName, setFolderName] = useState('')
  const [fileName, setFileName] = useState('')
  const [fileId, setFileId] = useState(null)

  // Store hooks
  const {
    fetchFamilyFiles,
    familyFiles,
    familySubfolders,
    fetchFamilyFolders,
    fetchFamilySubfolders,
    familyFolderFiles,
    fetchFamilyFolderFiles,
    folderFiles,
    createFamilyFolders,
    familyFolders,
    createSubFolders,
    createFamilySubFolders,
    createFolders,
    uploadFile,
    deleteFile,
    deleteFolderFile,
    folderDelete,
    deleteFolder,
    fileFolderUpload,
    uploadFileToFolder,
    fileUpload,
  } = useFileStore()

  const { member, getAFamilyMember } = useFamilyStore()

  const { filteredFiles } = useSearchStore()
  const fam = member[memberId]

  // Load family member and files on component mount
  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true)
        setError(null)

        // Load family member data
        const result = await getAFamilyMember(memberId)
        console.log('Family member result', result)

        // Load family files
        await fetchFamilyFiles(memberId)
        await fetchFamilyFolders(memberId)

        // if (currentFolder) {
        //   await fetchFamilySubfolders(memberId, folderId)
        //   await fetchFamilyFolderFiles(memberId, folderId)
        // }

        // await createFamilySubFolders(clientId, memberId, folderId)
      } catch (err) {
        console.error('Error loading data:', err)
        setError('Failed to load member data or files')
      } finally {
        setLoading(false)
      }
    }

    if (clientId && memberId) {
      loadData()
    }
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setContextMenu(null)
      }
    }
    window.addEventListener('click', handleClickOutside)
    return () => window.removeEventListener('click', handleClickOutside)
  }, [
    refresh,
    clientId,
    memberId,
    folderId,
    getAFamilyMember,
    fetchFamilyFiles,
    fetchFamilyFolders,
    uploadFileToFolder,
    uploadFile,
    currentFolder,
    fetchFamilySubfolders,
    fetchFamilyFolderFiles,
  ])
  // Hide menu when clicking outside
  // useEffect(() => {}, [])

  const memb = fam
  console.log(memb)
  // Debug logging to identify the issue
  console.log('Raw member object:', member)
  console.log('memberId:', memberId)
  console.log('folder ID', folderId)
  console.log('fam object:', fam)
  console.log('fam type:', typeof fam)

  // Get current file structure
  // const memberKey = `${clientId}-${memberId}`
  JSON.stringify(familyFiles, null, 2)

  const fileStructure =
    (familyFolders?.[memberId] && familyFiles?.[memberId]) ||
    familySubfolders?.[memberId]?.[folderId] ||
    familyFolderFiles?.[memberId]?.[folderId]
      ? {
          folders: familyFolders[memberId] || [],
          subFolders: familySubfolders[(memberId, folderId)] || [],
          folderFiles: familyFolderFiles[(memberId, folderId)] || [],
          rootFiles: familyFiles[memberId].db_files || [],
        }
      : { rootFiles: [], folders: [], subFolders: [], folderFiles: [] }
  console.log('Files in db_files array:', familyFiles?.[memberId])

  // const fileFolder = familyFolders?.[memberId]?.db_folders

  console.log('Folders contents:', familyFiles[memberId])
  // Loading and error states
  if (loading) {
    return (
      <div className="bg-neutral-100 flex flex-row justify-center w-full min-h-screen">
        <div className="bg-neutral-100 w-[1440px] p-8 flex items-center justify-center">
          <div className="text-center">
            <div className="text-4xl mb-4">⏳</div>
            <h2 className="text-xl font-semibold mb-2">Loading...</h2>
            <p className="text-gray-600">
              Please wait while we load the member files
            </p>
          </div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="bg-neutral-100 flex flex-row justify-center w-full min-h-screen">
        <div className="bg-neutral-100 w-[1440px] p-8">
          <div className="text-center">
            <div className="text-4xl mb-4">❌</div>
            <h1 className="text-2xl font-bold mb-4">Error Loading Data</h1>
            <p className="text-red-600 mb-4">{error}</p>
            <button
              onClick={() => navigate(`/dashboard/client/${clientId}/family`)}
              className="bg-[#3d6be0] text-white px-6 py-2 rounded-lg hover:bg-blue-600"
            >
              Back to Family Members
            </button>
          </div>
        </div>
      </div>
    )
  }

  if (!memb) {
    return (
      <div className="bg-neutral-100 flex flex-row justify-center w-full min-h-screen">
        <div className="bg-neutral-100 w-[1440px] p-8">
          <div className="text-center">
            <h1 className="text-2xl font-bold mb-4">Member Not Found</h1>
            <button
              onClick={() => navigate(`/dashboard/client/${clientId}/family`)}
              className="bg-[#3d6be0] text-white px-6 py-2 rounded-lg hover:bg-blue-600"
            >
              Back to Family Members
            </button>
          </div>
        </div>
      </div>
    )
  }

  const handleCreateFolder = async (folderName, fileCount) => {
    try {
      if (folderId) {
        await createFamilySubFolders(memberId, folderId, folderName, fileCount)
        setShowCreateFolder(false)
        await fetchFamilySubfolders(memberId, folderId)
      } else {
        await createFamilyFolders(memberId, folderName, fileCount)
        setShowCreateFolder(false)
      }

      // Refresh files after creating folder
      await fetchFamilyFolders(memberId)
      await apiClient.fetchFamilySubfolders(memberId, folderId)
    } catch (error) {
      console.error('Error creating folder:', error)
      alert('Failed to create folder. Please try again.')
    }
  }

  const handleUploadFile = async (fileData) => {
    // Comprehensive validation
    // if (!currentFolder) {
    //   alert('Not a folder to upload to')
    //   return
    // }
    alert(fileData.url)

    if (!fileData.name || typeof fileData.name !== 'string') {
      alert('Invalid file data - missing or invalid name:', fileData)
      return
    }

    try {
      // const folderIdn = currentFolder ? currentFolder.id : null
      if (currentFolder) {
        await uploadFileToFolder(memberId, currentFolder.id, fileData.file)
        setShowUploadFile(false)
        await fetchFamilyFolderFiles(memberId, folderId)
        // setRefresh((prev) => prev + 1)
        return navigate(
          `/dashboard/client/${clientId}/family/${memberId}/folders/${currentFolder.id}/subfolders/`
        )
      } else {
        await uploadFile(memberId, fileData.file)
        setShowUploadFile(false)
        await fetchFamilyFiles(memberId)
      }

      // Refresh files after upload
      // await fetchFamilyFiles(memberId)
      // await fetchFamilyFolderFiles(memberId, folderId)
    } catch (error) {
      console.error('Error uploading file to folder:', error)
      alert('Error uploading file. Please try again.')
    }
    // setRefresh((prev)=> prev + 1)
  }

  // handle drag drop upload
  const handleDragDropUpload = async (fileData) => {
    await handleUploadFile(fileData)
  }

  const handleFolderClick = async (folder) => {
    // const famsubfold = await fetchFamilyFolderFiles(memberId, folderId)
    await fetchFamilySubfolders(memberId, folder.id)
    await fetchFamilyFolderFiles(memberId, folder.id)
    setCurrentFolder(folder)

    if (folder.id) {
      navigate(
        `/dashboard/client/${clientId}/family/${memberId}/folders/${folder.id}/subfolders/`
      )
    }

    // return folder.id
  }

  console.log('Subfolders display', familySubfolders)

  const handleBackClick = () => {
    setCurrentFolder(null)
    return navigate(`/dashboard/client/${clientId}/family/${memberId}/files/`)
  }

  const getFileIcon = (fileName) => {
    if (!fileName || typeof fileName !== 'string') return '📎'
    const extension = fileName.split('.').pop()?.toLowerCase() || ''
    switch (extension) {
      case 'pdf':
        return '📄'
      case 'doc':
      case 'docx':
        return '📝'
      case 'xls':
      case 'xlsx':
      case 'csv':
        return '📊'
      case 'ppt':
      case 'pptx':
        return '📽️'
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'bmp':
      case 'webp':
        return '🖼️'
      case 'mp4':
      case 'avi':
      case 'mov':
      case 'wmv':
        return '🎬'
      case 'mp3':
      case 'wav':
      case 'ogg':
        return '🎵'
      case 'txt':
      case 'md':
        return '📝'
      default:
        return '📎'
    }
  }
  // inside MemberFiles.jsx

  const handleFilePreview = (file) => {
    const safeFile = sanitizeFileObject(file)
    setSelectedFile(safeFile)
    setPreviewFile(safeFile)
    setIsPreviewModalOpen(true)
  }

  const handleFullPreview = () => {
    if (selectedFile) {
      setPreviewFile(selectedFile)
      setIsPreviewModalOpen(true)
    } else {
      console.warn('No file selected for preview')
    }
  }

  // hanlde file select function
  const handleFileSelect = (file) => {
    try {
      const safeFile = sanitizeFileObject(file)
      if (safeFile) {
        safeFile.icon = getFileIcon(safeFile.name)
        setSelectedFile(safeFile)
      } else {
        console.warn('Invalid file provided to select:', file)
        setSelectedFile(null)
      }
    } catch (error) {
      console.error('Error selecting file:', error)
      setSelectedFile(null)
    }
  }

  const handleDeleteFile = async () => {
    // Validate inputs
    if (!fileId) {
      console.error('No file ID provided for deletion')
      return
    }

    try {
      if (currentFolder) {
        await apiClient.deleteFolderFile(memberId, currentFolder.id, fileId)
        await fetchFamilyFolderFiles(memberId, folderId)
      } else {
        await apiClient.deleteFile(memberId, fileId)
        await fetchFamilyFiles(memberId)
      }
      setShowDeleteFileModal(false)
      // Clear preview and selection if the deleted file was selected
      if (previewFile?.id === fileId) {
        setPreviewFile(null)
      }
      if (selectedFile?.id === fileId) {
        setSelectedFile(null)
      }

      // Refresh files after deletion
    } catch (error) {
      console.error('Error deleting file:', error)
      alert('Failed to delete file. Please try again.')
    }
  }

  // download file
  const handleDownloadFile = async (file) => {
    try {
      if (!file || !file.previewLink) {
        console.error('Missing file or file_url')
        return
      }

      // Fetch file blob (ensures CORS and auth-safe)
      const response = await fetch(file.previewLink, {
        method: 'GET',
        headers: {
          // Add auth header if your API requires it
          // Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`)
      }

      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)

      // Create a link element for download
      const link = document.createElement('a')
      link.href = url

      // Determine file name safely
      const filename =
        file.file_name ||
        // file.name ||
        file.path_display?.split('/').pop() ||
        'downloaded_file'

      link.download = filename

      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Download failed:', error)
      alert('Unable to download file. Please try again.')
    }
  }

  // delete folder
  const handleDeleteFolder = async () => {
    // if (
    //   window.confirm(
    //     'Are you sure you want to delete this folder and all its contents?'
    //   )
    // ) {
    try {
      await deleteFolder(memberId, foldId)
      setShowDeleteFolderModal(false)
      // If currently viewing the deleted folder, go back to main view
      if (currentFolder && currentFolder.id === foldId) {
        setCurrentFolder(null)
      }

      // Refresh files after deletion
      await fetchFamilySubfolders(memberId, folderId)
      await fetchFamilyFolders(memberId)
    } catch (error) {
      console.error('Error deleting folder:', error)
      // alert('Failed to delete folder. Please try again.')
    }
    // }
  }

  // update folder

  // const handleUpdateFolder = async (folderId) => {
  //   await apiClient.updateFolder(memberId, folderId, name)
  // }

  // Rename a file
  // const handleRename = async (file, newName) => {
  //   await apiClient.renameFile(file.id, newName)
  // }

  // Delete a file
  // const handleDelete = async (file) => {
  //   await apiClient.deleteFolderFile(file.id)
  // }
  // Right-click handler
  const handleContextMenu = (e, item) => {
    e.preventDefault()

    // Determine if it's a file or subfolder based on properties
    const isSubfolder =
      item.hasOwnProperty('name') &&
      !Object.prototype.hasOwnProperty.call(item, 'file_name')

    setContextMenu({
      x: e.clientX + 9,
      y: e.clientY - 15,
      file: isSubfolder ? null : item,
      sub: isSubfolder ? item : null,
    })
  }

  // Rename logic
  const handleRenameFile = async (file) => {
    if (newName.trim() && newName !== file.file_name) {
      await apiClient.renameFileInFolder(memberId, folderId, file.id, newName)
      await fetchFamilyFolderFiles(memberId, folderId)
    }
    setRenamingFile(null)
    setNewName('')
  }

  const handleRenameFolder = async (folder) => {
    if (newName.trim() && newName !== folder.name) {
      await apiClient.renameFolder(memberId, folder.id, newName)
      await fetchFamilyFolders(memberId)
    }
    setRenamingFolder(null)
    setNewName('')
  }

  // Rename root file (files not in folders)
  const handleRenameRootFile = async (file) => {
    if (newName.trim() && newName !== file.file_name) {
      await apiClient.renameFile(memberId, file.id, newName)
      // Refresh files after rename
      await fetchFamilyFiles(memberId)
    }
    setRenamingFile(null)
    setNewName('')
  }

  const handleUpdateFileCount = async (fileCount) => {
    try {
      if (foldId) {
        await apiClient.updateFileCount(memberId, foldId, fileCount)
        await fetchFamilyFiles(memberId)
        // setRefresh((prev) => prev + 1)
      }

      // alert(foldId)
      // setNumOfFile(null)
      setShowUpdateFolder(false)
    } catch (error) {
      setShowUpdateFolder(true)
      return { error: error }
    }
  }

  // const handleUpdateFamilyFolder = async (folder) => {
  //   await apiClient.updateFolder(memberId, folder.id, newFolderName, fileCount)
  //   await fetchFamilyFolders(memberId)
  // }
  // if (fileStructure.rootFiles)
  return (
    <div className="flex h-screen bg-gray-100">
      <SideBar />
      <div className="flex-1 flex flex-col">
        <Navbar />

        <div className="p-4 flex-1 overflow-auto p-6 bg-gray-100">
          <ResizablePanes
            showRightPane={showPreviewPane}
            defaultLeftWidth={showPreviewPane ? 70 : 100}
            minLeftWidth={40}
            maxLeftWidth={85}
            leftPane={
              <div className="h-full pr-4 overflow-auto">
                {/* Header */}
                <div className="bg-white rounded-lg p-6 mb-6">
                  <div className="flex items-center justify-between">
                    <div>
                      <button
                        onClick={() =>
                          navigate(`/dashboard/client/${clientId}/family`)
                        }
                        className="text-[#3d6be0] hover:underline mb-2 flex items-center gap-2"
                      >
                        ← Back to Family Members
                      </button>
                      {/* {familyMembers[0][2] === 'primary applicant' ? (
                      <div key>
                        <span>{familyMembers.full_name}</span>
                      </div>
                    ) : (
                      ''
                    )} */}
                      <h1 className="text-3xl font-bold text-black">
                        {memb.full_name} &apos;s Files
                      </h1>

                      <p className="text-gray-600 mt-2">{memb.relationship}</p>

                      {currentFolder && (
                        <div className="mt-2">
                          <button
                            onClick={handleBackClick}
                            className="text-[#3d6be0] hover:underline flex items-center gap-1"
                          >
                            ← Back to main folder
                          </button>
                          <p className="text-lg font-semibold text-gray-800 mt-1">
                            {currentFolder.icon} {currentFolder.name}
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Action Buttons */}
                    <div className="flex gap-3">
                      <button
                        onClick={() => setShowPreviewPane(!showPreviewPane)}
                        className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-colors ${
                          showPreviewPane
                            ? 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                        }`}
                        title={
                          showPreviewPane
                            ? 'Hide Preview Pane'
                            : 'Show Preview Pane'
                        }
                      >
                        {showPreviewPane ? '👁️‍🗨️' : '👁️'} Preview
                      </button>
                      <button
                        onClick={() => setShowCreateFolder(true)}
                        className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 flex items-center gap-2"
                      >
                        📁 Create Folder
                      </button>
                      <button
                        onClick={() => setShowUploadFile(true)}
                        className="bg-[#3d6be0] text-white px-4 py-2 rounded-lg hover:bg-blue-600 flex items-center gap-2"
                      >
                        📤 Upload File
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  className="cursor-pointer h-8 text-left mb-2 rounded-lg text-blue-900 text-md font-bold underline hover:text-green-500"
                  onClick={() => {
                    setSummaryModal(true)
                  }}
                >
                  Summary
                </div>

                {/* File Browser */}
                <DragDropZone
                  onFileUpload={handleDragDropUpload}
                  className="bg-white rounded-lg p-6"
                >
                  {!currentFolder ? (
                    // Main folder view
                    <div>
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-xl font-semibold">
                          Folders & Files
                        </h2>
                        <div className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
                          💡 Drag and drop files anywhere to upload
                        </div>
                      </div>

                      {/* Folders Grid */}
                      {fileStructure.folders &&
                        fileStructure.folders.length > 0 && (
                          <div className="mb-8">
                            <h3 className="text-lg font-medium mb-3 text-gray-700">
                              Folders
                            </h3>
                            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                              {fileStructure.folders.map((folder) => (
                                <div
                                  key={folder.id}
                                  onContextMenu={(e) =>
                                    handleContextMenu(e, folder)
                                  }
                                  className="bg-gray-50 p-4 rounded-lg border border-gray-200 group relative"
                                >
                                  <div
                                    className="text-center cursor-pointer"
                                    onClick={() => handleFolderClick(folder)}
                                  >
                                    <div className="text-4xl mb-2">
                                      {folder.icon || '📁'}
                                    </div>
                                    {/* <p className="font-medium text-gray-800">
                                      {folder.name}
                                    </p> */}
                                    <div>
                                      {renamingFolder === folder.id ? (
                                        <input
                                          autoFocus
                                          className="border rounded p-1 w-full"
                                          value={newName}
                                          onChange={(e) =>
                                            setNewName(e.target.value)
                                          }
                                          onBlur={() =>
                                            handleRenameFolder(folder)
                                          }
                                          onKeyDown={(e) =>
                                            e.key === 'Enter'
                                              ? handleRenameFolder(folder)
                                              : null
                                          }
                                        />
                                      ) : (
                                        <p className="font-medium text-gray-800">
                                          {folder.name}
                                        </p>
                                      )}
                                      {/* <p className="text-sm text-gray-500">
                                        {` created at ${folder.created_at.slice(0, 10)}` ||
                                          'Unknown date'}
                                      </p> */}
                                    </div>
                                    <div className="flex justify-center items-center">
                                      <p className="text-sm text-gray-300 hover:text-gray-500">
                                        {1 || 0} files
                                      </p>
                                      {/* <p className="text-sm text-gray-300 hover:text-blue-500">
                                        {folder.required_num_of_file || 0} Count
                                      </p> */}
                                    </div>
                                  </div>
                                  {/* <button 
                                    onClick={(e) => {
                                      e.stopPropagation(),
                                        handleUpdateFolder(folder)
                                    }}
                                    className="absolute top-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity text-blue-300 p-1 bg-gray-800 rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-gray-600"
                                  >
                                    <Edit />
                                  </button> */}

                                  {/* Update button */}
                                  {/* <button
                                    onClick={() => {
                                      setShowUpdateFolder(true)
                                      setFolderId(folder.id)
                                    }}
                                    className="absolute top-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity text-blue-300 p-1 bg-gray-800 rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-gray-600"
                                  >
                                    <Edit />
                                  </button> */}
                                  {/* Delete button */}
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      // handleDeleteFolder(folder.id)
                                      setFolderId(folder.id)
                                      setFolderName(folder.name)
                                      setShowDeleteFolderModal(true)
                                    }}
                                    className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-blue-600"
                                  >
                                    {folder.required_num_of_file}
                                  </button>
                                </div>
                              ))}
                            </div>
                            {/* Context Menu for Root Files */}
                            {contextMenu && contextMenu.sub && (
                              <ul
                                ref={menuRef}
                                className="fixed bg-white border rounded shadow-md w-[10%]"
                                style={{
                                  top: `${contextMenu.y}px`,
                                  left: `${contextMenu.x}px`,
                                  zIndex: 1000,
                                }}
                              >
                                <div className="flex justify-center items-center h-8 p-2 ">
                                  <img src={Logo} alt="" className="h-8 w-8" />
                                </div>
                                <hr />
                                <li
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                  onClick={() => {
                                    setRenamingFolder(contextMenu.sub.id)
                                    setNewName(contextMenu.sub.name)
                                    setContextMenu(null)
                                  }}
                                >
                                  Rename
                                </li>
                                <li
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                  onClick={() => {
                                    setFolderId(contextMenu.sub.id)
                                    setShowUpdateFolder(true)

                                    // setNumOfFile(
                                    //   contextMenu.sub.required_num_of_file
                                    // )
                                    setContextMenu(null)
                                  }}
                                >
                                  Set File Count
                                </li>

                                <li
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-600"
                                  onClick={() => {
                                    setFolderId(contextMenu.sub.id)
                                    setShowDeleteFolderModal(true)
                                    setContextMenu(null)
                                  }}
                                >
                                  Delete
                                </li>
                              </ul>
                            )}
                          </div>
                        )}

                      {/* Root Files */}
                      {fileStructure.rootFiles &&
                        fileStructure.rootFiles.length > 0 && (
                          <div>
                            <h3 className="text-lg font-medium mb-3 text-gray-700">
                              Files
                            </h3>
                            <div className="space-y-2">
                              {fileStructure.rootFiles
                                .filter((file) => file && file.file_name)
                                .map((file) => (
                                  <div
                                    key={file.id || Math.random()}
                                    onContextMenu={(e) =>
                                      handleContextMenu(e, file)
                                    }
                                    className={`flex items-center justify-between p-3 rounded-lg border border-gray-200 group cursor-pointer transition-colors ${
                                      selectedFile?.id === file.id
                                        ? 'bg-blue-50 border-blue-300'
                                        : 'bg-gray-50 hover:bg-gray-100'
                                    }`}
                                    onClick={() => handleFileSelect(file)}
                                  >
                                    <div className="flex items-center gap-3">
                                      <span className="text-2xl">
                                        {getFileIcon(file.file_name || '')}
                                      </span>
                                      <div>
                                        {renamingFile === file.id ? (
                                          <input
                                            autoFocus
                                            className="border rounded p-1 w-full"
                                            value={newName}
                                            onChange={(e) =>
                                              setNewName(e.target.value)
                                            }
                                            onBlur={() =>
                                              handleRenameRootFile(file)
                                            }
                                            onKeyDown={(e) =>
                                              e.key === 'Enter'
                                                ? handleRenameRootFile(file)
                                                : null
                                            }
                                          />
                                        ) : (
                                          <p className="font-medium text-gray-800">
                                            {file.file_name || 'Unknown File'}
                                          </p>
                                        )}
                                        <p className="text-sm text-gray-500">
                                          {file.file_size_formatted ||
                                            'Unknown size'}{' '}
                                          •{' '}
                                          {` created at ${file.created_at.slice(0, 10)}` ||
                                            'Unknown date'}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="flex items-center gap-2">
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          handleFilePreview(file)
                                        }}
                                        className="text-[#3d6be0] hover:underline text-sm"
                                      >
                                        Preview
                                      </button>
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          handleDownloadFile(file)
                                        }}
                                        className="text-[#3d6be0] hover:underline text-sm"
                                      >
                                        Download
                                      </button>
                                      {/* <button
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          handleDeleteFile(file.id)
                                        }}
                                        className="opacity-0 group-hover:opacity-100 transition-opacity text-red-500 hover:text-red-700 text-sm"
                                      >
                                        Delete
                                      </button> */}
                                    </div>
                                  </div>
                                ))}
                            </div>

                            {/* Context Menu for Root Files */}
                            {contextMenu &&
                              contextMenu.file &&
                              !currentFolder &&
                              !contextMenu.sub && (
                                <ul
                                  ref={menuRef}
                                  className="fixed bg-white border rounded shadow-md w-[10%]"
                                  style={{
                                    top: `${contextMenu.y}px`,
                                    left: `${contextMenu.x}px`,
                                    zIndex: 1000,
                                  }}
                                >
                                  <div className="flex justify-center items-center h-8 p-2 ">
                                    <img
                                      src={Logo}
                                      alt=""
                                      className="h-8 w-8"
                                    />
                                  </div>
                                  <hr />
                                  <li
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                      setRenamingFile(contextMenu.file.id)
                                      setNewName(contextMenu.file.file_name)
                                      setContextMenu(null)
                                    }}
                                  >
                                    Rename
                                  </li>
                                  <li
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-600"
                                    onClick={() => {
                                      setFileId(contextMenu.file.id)
                                      setFileName(contextMenu.file.file_name)
                                      setShowDeleteFileModal(true)
                                      setContextMenu(null)
                                    }}
                                  >
                                    Delete
                                  </li>
                                </ul>
                              )}
                          </div>
                        )}
                      {(!fileStructure.folders ||
                        fileStructure.folders.length === 0) &&
                        (!fileStructure.rootFiles ||
                          fileStructure.rootFiles.length === 0) && (
                          <div className="text-center py-12">
                            <div className="text-6xl mb-4">📁</div>
                            <h3 className="text-xl font-medium text-gray-600 mb-2">
                              No files or folders yet
                            </h3>
                            <p className="text-gray-500">
                              Create a folder or upload files to get started
                            </p>
                          </div>
                        )}
                    </div>
                  ) : (
                    // Folder contents view
                    <div>
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-xl font-semibold">
                          {currentFolder.icon || '📁'} {currentFolder.name}{' '}
                          Files
                        </h2>
                        <div className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
                          💡 Drag and drop files here to add to this folder
                        </div>
                      </div>
                      {/* Subfolders Grid */}
                      {fileStructure.subFolders &&
                        fileStructure.subFolders.length > 0 && (
                          <div className="mb-8">
                            <h3 className="text-lg font-medium mb-3 text-gray-700">
                              Subfolders
                            </h3>
                            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                              {familySubfolders[(memberId, folderId)]
                                .filter((file) => file)
                                .map((sub) => (
                                  <div
                                    key={sub.id}
                                    onContextMenu={(e) =>
                                      handleContextMenu(e, sub)
                                    }
                                    className="bg-gray-50 p-4 rounded-lg border border-gray-200 group relative"
                                    onClick={() => handleFolderClick(sub)}
                                  >
                                    <div className="text-center cursor-pointer">
                                      <div className="text-4xl mb-2">
                                        {sub.icon || '📁'}
                                      </div>
                                      {renamingFolder === sub.id ? (
                                        <input
                                          autoFocus
                                          className="border rounded p-1 w-full"
                                          value={newName}
                                          onChange={(e) =>
                                            setNewName(e.target.value)
                                          }
                                          onBlur={() => handleRenameFolder(sub)}
                                          onKeyDown={(e) =>
                                            e.key === 'Enter'
                                              ? handleRenameFolder(sub)
                                              : null
                                          }
                                        />
                                      ) : (
                                        <p className="font-medium text-gray-800">
                                          {sub.name}
                                        </p>
                                      )}

                                      <p className="text-sm text-gray-500">
                                        {sub.required_num_of_file || 0} files
                                      </p>
                                      {/* Delete button */}
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          setFolderId(sub.id)
                                          setShowDeleteFolderModal(true)
                                        }}
                                        className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity bg-blue-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm hover:bg-blue-600"
                                      >
                                        {sub.required_num_of_file}
                                      </button>
                                    </div>
                                  </div>
                                ))}

                              {/* Context Menu for Subfolders */}
                              {contextMenu && contextMenu.sub && (
                                <ul
                                  ref={menuRef}
                                  className="fixed bg-white border rounded shadow-md w-[10%]"
                                  style={{
                                    top: `${contextMenu.y}px`,
                                    left: `${contextMenu.x}px`,
                                    zIndex: 1000,
                                  }}
                                >
                                  <div className="flex justify-center items-center h-8 p-2 ">
                                    <img
                                      src={Logo}
                                      alt=""
                                      className="h-8 w-8"
                                    />
                                  </div>
                                  <hr />
                                  <li
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                      setRenamingFolder(contextMenu.sub.id)
                                      setNewName(contextMenu.sub.name)
                                      setContextMenu(null)
                                    }}
                                  >
                                    Rename
                                  </li>
                                  <li
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                      setFolderId(contextMenu.sub.id)
                                      setShowUpdateFolder(true)

                                      // setNumOfFile(
                                      //   contextMenu.sub.required_num_of_file
                                      // )
                                      setContextMenu(null)
                                    }}
                                  >
                                    Set File Count
                                  </li>

                                  <li
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-600"
                                    onClick={() => {
                                      setFolderId(contextMenu.sub.id)
                                      setContextMenu(null)
                                      setShowDeleteFolderModal(true)
                                    }}
                                  >
                                    Delete
                                  </li>
                                </ul>
                              )}
                            </div>
                          </div>
                        )}
                      {fileStructure.folderFiles &&
                      fileStructure.folderFiles.length > 0 ? (
                        <div className="space-y-2">
                          {fileStructure.folderFiles.map((file) => (
                            <div
                              key={file.id}
                              onContextMenu={(e) => handleContextMenu(e, file)}
                              className={`flex items-center justify-between p-3 rounded-lg border border-gray-200 group cursor-pointer transition-colors ${
                                selectedFile?.id === file.id
                                  ? 'bg-blue-50 border-blue-300'
                                  : 'bg-gray-50 hover:bg-gray-100'
                              }`}
                              onClick={() => handleFileSelect(file)}
                            >
                              <div className="flex items-center gap-3">
                                <span className="text-2xl">
                                  {getFileIcon(file.file_name)}
                                </span>
                                <div>
                                  {renamingFile === file.id ? (
                                    <input
                                      autoFocus
                                      className="border rounded p-1 w-full"
                                      value={newName}
                                      onChange={(e) =>
                                        setNewName(e.target.value)
                                      }
                                      onBlur={() => handleRenameFile(file)}
                                      onKeyDown={(e) =>
                                        e.key === 'Enter'
                                          ? handleRenameFile(file)
                                          : null
                                      }
                                    />
                                  ) : (
                                    <p className="font-medium text-gray-800">
                                      {file.file_name}
                                    </p>
                                  )}
                                  <p className="text-sm text-gray-500">
                                    {file.file_size_formatted} •
                                    {` created at ${file.created_at.slice(0, 10)}`}
                                    {/* {new Date().toISOString} */}
                                  </p>
                                </div>
                              </div>
                              <div className="flex items-center gap-2">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    handleFilePreview(file)
                                  }}
                                  className="text-[#3d6be0] hover:underline text-sm"
                                >
                                  Preview
                                </button>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    handleDownloadFile(file)
                                  }}
                                  className="text-[#3d6be0] hover:underline text-sm"
                                >
                                  Download
                                </button>
                                {/* <button
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    handleDeleteFile(
                                      file.id,
                                      familyFolderFiles.id
                                    )
                                  }}
                                  className="opacity-0 group-hover:opacity-100 transition-opacity text-red-500 hover:text-red-700 text-sm"
                                >
                                  Delete
                                </button> */}
                              </div>

                              {/* Context Menu */}
                              {contextMenu && contextMenu.file && (
                                <ul
                                  ref={menuRef}
                                  className="fixed bg-white border rounded shadow-md w-[10%]"
                                  style={{
                                    top: `${contextMenu.y}px`,
                                    left: `${contextMenu.x}px`,
                                    zIndex: 1000,
                                  }}
                                >
                                  <div className="flex justify-center items-center h-8 p-2 ">
                                    <img
                                      src={Logo}
                                      alt=""
                                      className="h-8 w-8"
                                    />
                                  </div>
                                  <hr />
                                  <li
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => {
                                      setRenamingFile(contextMenu.file.id)
                                      setNewName(contextMenu.file.file_name)
                                      setContextMenu(null)
                                    }}
                                  >
                                    Rename
                                  </li>
                                  <li
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-600"
                                    onClick={() => {
                                      setFileId(contextMenu.file.id)
                                      setShowDeleteFileModal(true)
                                      setContextMenu(null)
                                    }}
                                  >
                                    Delete
                                  </li>
                                </ul>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-center py-12">
                          <div className="text-6xl mb-4">📄</div>
                          <h3 className="text-xl font-medium text-gray-600 mb-2">
                            No files in this folder
                          </h3>
                          <p className="text-gray-500">
                            Upload files to this folder to get started
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </DragDropZone>
                {/* Modals */}
                {showUpdateFolder && (
                  <UpdateFamilyFolderModal
                    onUpdateFolder={handleUpdateFileCount}
                    onCancel={() => setShowUpdateFolder(false)}
                  />
                )}
                {showCreateFolder && (
                  <CreateFolderForm
                    onCreateFolder={handleCreateFolder}
                    onCancel={() => setShowCreateFolder(false)}
                  />
                )}
                {showUploadFile && (
                  <UploadFileForm
                    onUploadFile={handleUploadFile}
                    onCancel={() => setShowUploadFile(false)}
                    targetFolder={currentFolder}
                  />
                )}
                {showSummaryModal && (
                  <SummaryModal onCancel={() => setSummaryModal(false)} />
                )}
                {/* {previewFile && (
                  <FilePreview
                    file={previewFile}
                    onClose={() => setPreviewFile(null)}
                  />
                )} */}
                {/* Reusable DeleteModal */}
                {showDeleteFolderModal && (
                  <DeleteFolderModal
                    isOpen={() => setShowDeleteFolderModal(true)}
                    title="Confirm Delete"
                    message={`Are you sure you want to delete "${folderName} folder"?`}
                    onConfirm={handleDeleteFolder}
                    onCancel={() => setShowDeleteFolderModal(false)}
                  />
                )}
                {showDeleteFileModal && (
                  <DeleteFileModal
                    isOpen={() => setShowDeleteFileModal(true)}
                    title="Confirm Delete"
                    message={`Are you sure you want to delete "${fileName} file"?`}
                    onConfirm={handleDeleteFile}
                    onCancel={() => setShowDeleteFileModal(false)}
                  />
                )}
              </div>
            }
            rightPane={
              <div className="h-full pl-4">
                <div className="bg-white rounded-lg p-6 h-full flex flex-col">
                  {selectedFile ? (
                    <>
                      {/* File Info Header */}
                      <div className="flex items-center gap-3 mb-4 pb-4 border-b border-gray-200 flex-shrink-0">
                        <span className="text-3xl">
                          {selectedFile.icon || '📎'}{' '}
                        </span>
                        <div className="flex-1 min-w-0">
                          <h3 className="font-semibold text-gray-800 truncate">
                            {selectedFile.name}
                          </h3>
                          <p className="text-sm text-gray-500">
                            {selectedFile.size} • {selectedFile.uploadDate}
                          </p>
                        </div>
                      </div>

                      {/* Preview Content */}
                      <div className="flex-1 mb-4 min-h-0">
                        <h4 className="font-medium text-gray-700 mb-3">
                          Preview
                        </h4>
                        <div className="border border-gray-200 rounded-lg overflow-hidden bg-gray-50 h-full">
                          <ErrorBoundary>
                            <FilePreviewPane file={selectedFile} />
                          </ErrorBoundary>
                        </div>
                      </div>

                      {/* Action Buttons */}
                      <div className="space-y-2 flex-shrink-0">
                        <button
                          onClick={handleFullPreview}
                          className="w-full px-4 py-2 bg-[#3d6be0] text-white rounded-lg hover:bg-blue-600 transition-colors"
                        >
                          Full Preview
                        </button>
                        <button
                          onClick={() => handleDownloadFile(selectedFile)}
                          className="w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                        >
                          Download
                        </button>
                        <button
                          onClick={() => {
                            const folderId = currentFolder
                              ? currentFolder.id
                              : null
                            handleDeleteFile(selectedFile.id, folderId)
                          }}
                          className="w-full px-4 py-2 border border-red-300 text-red-600 rounded-lg hover:bg-red-50 transition-colors"
                        >
                          Delete File
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="text-center py-12 flex-1 flex flex-col justify-center">
                      <div className="flex justify-center text-6xl mb-4 text-center w-auto">
                        <img src={Logo} alt="" className="" />
                      </div>
                      <h3 className="text-lg font-medium text-gray-600 mb-2">
                        Select a file
                      </h3>
                      <p className="text-gray-500 text-sm">
                        Click on any file to see its preview and details here
                      </p>
                    </div>
                  )}
                </div>
              </div>
            }
          />
          {isPreviewModalOpen && previewFile && (
            <FilePreviewModal
              file={previewFile}
              onClose={() => setIsPreviewModalOpen(false)}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default MemberFiles
